import React, { useState } from "react";
import "../../styles/Quiz/ResultStep.css";
import config from "../../config/config";
import { trackCtaClick } from "../../utils/analytics";

export default function ResultStep({ resultData, sessionId, onClose }) {
  if (!resultData) {
    return (
      <div className="quiz-body quiz-result">
        <p>Loading results...</p>
      </div>
    );
  }

  const headerContent = resultData.result_title;
  const bodyContent = resultData.result_description;

  const checklist = resultData.benefits
    ? resultData.benefits.map((b) => b.benefit)
    : [];

  const button = {
    content: resultData.company_name
      ? `Click here to learn more about ${resultData.company_name}`
      : "Learn More",
    url: resultData.result_url || "#",
  };

  const logoUrl = resultData.company_logo;

  const handleCtaClick = () => {
    if (!sessionId || !button.url || button.url === "#") return;

    fetch(`${config.calculatorUrl}quiz/cta-click/${sessionId}/`, {
      method: "GET",
      headers: { Authorization: `${process.env.REACT_APP_API_KEY}` },
      keepalive: true,
    })
      .then((res) => {
        if (!res.ok) console.error(`Failed to track CTA click: ${res.status}`);
      })
      .catch((err) => console.error("CTA click tracking error:", err));

    trackCtaClick({ sessionId, company: resultData.company_name });

    onClose?.();
    window.open(button.url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="quiz-body quiz-result">
      {logoUrl && (
        <div className="quiz-result__logo">
          <img
            src={`${config.mainUrl}${logoUrl}`}
            alt={`${resultData.company_name} logo`}
          />
        </div>
      )}

      <h2 className="quiz-result__heading">{headerContent}</h2>

      <p className="quiz-result__text">{bodyContent}</p>

      {checklist.length > 0 && (
        <ul className="quiz-result__checklist">
          {checklist.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      )}

      <button type="button" className="quiz-cta" onClick={handleCtaClick}>
        {button.content}
      </button>
    </div>
  );
}
